import { TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { isEmpty, isNotEmpty } from "../../../helpers/StringHelpers"
import { PostalCodeValidator } from "../../../services/validation/address-employment-form/PostalCodeValidator"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"

const PostalCodeField = (props: FormFieldProps<string>) => {
    const { t } = useTranslation(`signup`)
    const {
        defaultValue,
        handleChange,
        errorText,
        isDisabled,
    } = props

    const [errorMessage, setErrorMessage] = useState(``)
    const [value, setValue] = useState(``)

    useEffect(() => {
        setErrorMessage(errorText ?? ``)
        setValue(defaultValue ?? ``)
    }, [defaultValue, errorText])

    const validateField = (value: string) => {
        const validator = new PostalCodeValidator()
        const validationText = t(validator.validate(value) ?? ``)
        setErrorMessage(validationText)
    }

    const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        const REGEX = /^[0-9\b]+$/g
        const text = event.target.value
        if (isEmpty(text) || REGEX.test(text)) {
            setValue(text)
            handleChange(text)
        }
    }
    const handleOnBlur = (event: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement, Element>) => {
        validateField(event.target.value)
    }

    return (
        <TextField
            error={isNotEmpty(errorMessage)}
            fullWidth
            id="postal-code"
            label={t(`postal_code`)}
            value={value}
            helperText={t(errorMessage)}
            inputProps={{ maxLength: 6 }}
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            disabled={isDisabled}
        />
    )
}

export { PostalCodeField }